import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import useApi from "../../../services/api";

function Common() {
  const { ApiGetFaqCommons } = useApi();
  const [commons, setCommons] = useState([]);

  async function getCommons() {
    const { data } = await ApiGetFaqCommons();

    console.log(data);

    setCommons(data);
  }

  useEffect(() => {
    getCommons();
  }, []);

  return (
    <div className="support-assuntos-warp">
      <h3 className="text-uppercase">{t("Support.Common")}</h3>
      <ul className="assuntos-list">
        {commons.map((C) => {
          return (
            <li>
              <div className="assuntos-intro">
                <p>
                  <Link to={DefRoutes.ResponseFaq.replace(":id", C.id)}>
                    {C.title} <i className="fal fa-angle-right"></i>
                  </Link>
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Common;
